export default __webpack_public_path__ + "static/bentoSectionBg1Mob-cce3c823a7eaa4c5eda60b1485b3271c.webp";